import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';

import { MAIN_DOMAIN } from '@app/app.constants';
import { ExExercise } from '@df/interfaces';

@Injectable({
    providedIn: 'root'
})
export class ExExerciseService {
    constructor(private http: HttpClient) {}

    getLessonExExercise(lessonId: number): Observable<ExExercise> {
        return this.http.get<ExExercise>(`${MAIN_DOMAIN}/api/lessons/lesson/${lessonId}/ex_exercise/`);
    }

    getAllExExercises(classId: number): Observable<ExExercise[]> {
        return this.http.get<ExExercise[]>(`${MAIN_DOMAIN}/api/lessons/${classId}/ex_exercises/`);
    }
}
